import React, { useEffect, useState } from 'react';
import { Button, Col, Input, Label, Row } from 'reactstrap';
import { checkNullValue, getUTCDate } from '../../utils/Util';
import CreateMarketingActivityFilter from '../../filters/CreateMarketingActivityFilterNew';
import {
  listTypes,
  MARKETING_STATUSES,
  moduleIds,
  UpdateAssigneeColumnHeader,
} from './activityHelper';
import MAutoCompleteMultiSelect from '../../components/MAutoCompleteMultiSelect';
import KTable from '../../components/KTable';
import MSelect from '../../components/MSelect';
import MDatePicker from '../../components/MDatePicker';
import { Image } from 'react-bootstrap';
import Calendar from '../../assets/img/calendar.svg';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import {
  fetchTargetDrops,
  getEmployeeList,
  marketingActivitySelector,
} from '../../features/marketingActivitySlice';
import Cancel from '../../assets/img/circleCancel.svg';
import successTick from '../../assets/img/successTick.svg';
import DisablesuccessTick from '../../assets/img/disableSuccess.svg';
import {
  EmployeeResultType,
  LocationFilterInitialState,
  SuggestionsType,
} from '../../utils/Types';
import { CLICK_ACTIONS } from '../../utils/Constant';
import AlertPopUP from '../modals/AlertPopUp';
import classNames from 'classnames';
import {
  fetchVillagesOfDistricts,
  locationFilterSelector,
} from '../../features/locationFilterSlice';
import { toast } from 'react-toastify';
import moment from 'moment';

interface IUpdateMarketingActivityProps {
  activityDetails: any;
  setUpdateActivity: (param: boolean) => void;
  comment: string;
  setComment: (comment: string) => void;
  showLoader: boolean;
  onSaveComment: () => void;
  onRemoveEmployee: (employeeId: number | string) => void;
  onUpdate: (
    selectedEmployees: any,
    assignedEmployeeIds: (number | string)[]
  ) => void;
  onPrimaryChange: (empId: string | number) => void;
}

const UpdateMarketingActivityPage: React.FunctionComponent<
  IUpdateMarketingActivityProps
> = ({
  activityDetails,
  setUpdateActivity,
  comment,
  setComment,
  onSaveComment,
  onRemoveEmployee,
  showLoader,
  onUpdate,
  onPrimaryChange,
}) => {
  const dispatch = useAppDispatch();
  const marketingTypes = useAppSelector(
    marketingActivitySelector
  ).marketingTypes;
  const [optionEmployeeName, setOptionEmployeeName] = useState<
    SuggestionsType[] | []
  >([]);
  const [selectedEmployees, setSelectedEmployees] = useState<SuggestionsType[]>(
    []
  );
  const [primaryEmpUniqueId, setPrimaryEmpUniqueId] = useState<any>();
  const [selectedEmployeesDetails, setSelectedEmployeesDetails] = useState<
    EmployeeResultType[]
  >([]);

  const employeeList = useAppSelector(marketingActivitySelector).employeeList;
  const [showAlertPopup, setShowAlertPopup] = useState<boolean>(false);
  const [removeEmpId, setRemoveEmpId] = useState<number | string>('');
  const [assignedEmployeeIds, setAssignedEmployeeIds] = useState<
    (string | number)[]
  >([]);
  const [isActivityStatusSubmited, setIsActivityStatusSubmited] =
    useState<boolean>(false);
  const [showChangePrimaryAlert, setShowChangePrimaryAlert] =
    useState<boolean>(false);
  const [newPrimaryEmpId, setNewPrimaryEmpId] = useState<number | string>('');
  const locationData: LocationFilterInitialState = useAppSelector(
    locationFilterSelector
  );

  useEffect(() => {
    if (employeeList?.length) {
      const districtIds: number[] = Array.from(
        new Set(
          employeeList.map((employee: any) => Number(employee.districtId))
        )
      );
      const existingDistrictVillages = Object.keys(
        locationData.cityOptions
      ).map((key) => Number(key));
      const districtsWithNoVillages = districtIds.filter(
        (id) => !existingDistrictVillages.includes(id)
      );
      if (districtsWithNoVillages.length) {
        dispatch(
          fetchVillagesOfDistricts({
            districtId: districtsWithNoVillages,
          })
        );
      }
    }
  }, [employeeList]);

  useEffect(() => {
    dispatch(fetchTargetDrops({ module: moduleIds.marketingTypes }));
  }, []);
  useEffect(() => {
    if (activityDetails?.zone && activityDetails?.state) {
      dispatch(
        getEmployeeList({
          zoneId: activityDetails?.zone,
          stateId: activityDetails?.state,
        })
      );
    }
    if (activityDetails?.activityStatusId) {
      setIsActivityStatusSubmited(
        ![
          MARKETING_STATUSES.ASSIGNED,
          MARKETING_STATUSES.INPROGESS,
          MARKETING_STATUSES.NEW,
        ].includes(activityDetails.activityStatusId)
      );
    }
  }, [activityDetails]);

  useEffect(() => {
    if (activityDetails?.employeeList?.length) {
      const assignedIds: (string | number)[] = [];
      const assignedEmployees = activityDetails.employeeList.map(
        (employee: any) => {
          if (employee.isPrimary) {
            setPrimaryEmpUniqueId(employee.candidateId);
          }
          assignedIds.push(employee.candidateId);
          return {
            value: employee.candidateId,
            label: employee.fullName,
            id: employee.employeeUniqueId,
          };
        }
      );
      setAssignedEmployeeIds(assignedIds);
      setSelectedEmployees(assignedEmployees);
    } else {
      setSelectedEmployees([]);
    }
  }, [activityDetails, activityDetails?.employeeList]);

  useEffect(() => {
    const employeeOptions: SuggestionsType[] = [];
    employeeList.map((emp) => {
      employeeOptions.push({
        label: emp.employeeName,
        value: emp.employeeId,
        id: emp.employeeUniqueId,
        disable: assignedEmployeeIds.includes(emp.employeeId),
      });
    });
    setOptionEmployeeName(employeeOptions);
  }, [employeeList, assignedEmployeeIds]);

  useEffect(() => {
    const empsObj: EmployeeResultType[] = [];
    if (selectedEmployees.length) {
      const selectedUniqueIds: (string | number)[] = selectedEmployees.map(
        (option) => option.value
      );
      selectedUniqueIds.forEach((id) => {
        let empInfo = employeeList.find((emp) => emp.employeeId === id);
        if (!empInfo) {
          const empData = activityDetails.employeeList.find(
            (emp: any) => emp.candidateId === id
          );

          empInfo = {
            employeeId: empData.candidateId,
            candidateUniqueId: empData.candidateUniqueId,
            employeeUniqueId: empData.employeeUniqueId,
            employeeName: empData.fullName,
            mobileNumber: empData.mobileNumber,
            cityId: empData.city,
            districtId: empData.district,
            zoneId: empData.zone,
            stateId: empData.state,
            role: empData.roleId,
            roleName: empData.roleName,
            email: empData.city,
            pincode: empData.pincode,
          };
        }
        empsObj.push(empInfo);
      });
      if (!selectedUniqueIds.includes(primaryEmpUniqueId)) {
        setPrimaryEmpUniqueId(null);
      }
    } else if (primaryEmpUniqueId) {
      setPrimaryEmpUniqueId(null);
    }
    setSelectedEmployeesDetails(empsObj);
  }, [selectedEmployees, employeeList]);

  const alertPopupToggle = (action: string) => {
    if (action === CLICK_ACTIONS.APPROVE) {
      onRemoveEmployee(removeEmpId);
    }
    setShowAlertPopup(false);
    setRemoveEmpId('');
  };

  const changePrimaryToggle = (action: string) => {
    if (action === CLICK_ACTIONS.APPROVE) {
      onPrimaryChange(newPrimaryEmpId);
    }
    setShowChangePrimaryAlert(false);
    setNewPrimaryEmpId('');
  };

  return (
    <div className="ml-4">
      <Label className="text-heading">
        {`Sales Activity Details: ${checkNullValue(activityDetails?.activityUniqueId)}`}
      </Label>

      <CreateMarketingActivityFilter
        filterValues={{
          year: activityDetails?.financialYear,
          season: activityDetails?.season,
          zone: activityDetails?.zone,
          state: activityDetails?.state,
          district: activityDetails?.district,
          village: activityDetails?.city,
          pincode: activityDetails?.pincode,
        }}
        setFilterValues={() => {}}
        onReset={() => {}}
        listType={listTypes.update}
        onSubmitFilter={() => {}}
        defaultLocationOptions={{
          zoneOption: [
            { value: activityDetails?.zone, label: activityDetails?.zoneName },
          ],
          stateOption: [
            {
              value: activityDetails?.state,
              label: activityDetails?.stateName,
            },
          ],
          districtOption: [
            {
              value: activityDetails?.district,
              label: activityDetails?.districtName,
            },
          ],
          cityOption: [
            { value: activityDetails?.city, label: activityDetails?.cityName },
          ],
        }}
      />
      <div className={'mt-3 container-parent parent-table'}>
        <div className="marketing-inner-div">
          <Label className="header-style">Assigned To</Label>
          <span className="text-danger">{` * `}</span>
          <span className="subtitle">(You can assign upto 6 employees)</span>
          <div
            className={classNames({
              'disabled-container': isActivityStatusSubmited,
            })}
          >
            <Row className="mt-2 disabled">
              <Col xs={12} md={4}>
                <MAutoCompleteMultiSelect
                  placeholder="Employee Name"
                  suggestions={optionEmployeeName}
                  value={selectedEmployees}
                  onChange={setSelectedEmployees}
                  noSuggestionsText={'No options'}
                  maxSelectable={6}
                />
              </Col>
            </Row>

            <KTable
              data={selectedEmployeesDetails}
              tableParentClass="table-parent-assign-employee mt-2"
              columnHeader={UpdateAssigneeColumnHeader}
              isLoading={showLoader}
              primaryEmpUniqueId={primaryEmpUniqueId}
              onAction={(data: any, headerItem: any) => {
                if (headerItem.action === CLICK_ACTIONS.REMOVE_ASSIGNEE) {
                  if (data?.employeeId === primaryEmpUniqueId) {
                    toast.error('Cannot remove primary employee');
                    return;
                  }
                  assignedEmployeeIds.includes(data?.employeeId);
                  if (assignedEmployeeIds.includes(data?.employeeId)) {
                    setRemoveEmpId(data.employeeId);
                    setShowAlertPopup(true);
                  } else {
                    const updatedSelectedEmployee = selectedEmployees.filter(
                      (emp) => emp.value != data?.employeeId
                    );
                    setSelectedEmployees(updatedSelectedEmployee);
                  }
                }
                if (
                  headerItem.action === CLICK_ACTIONS.SET_PRIMARY_ASSIGNEE &&
                  primaryEmpUniqueId != data.employeeId
                ) {
                  setNewPrimaryEmpId(data.employeeId);
                  setShowChangePrimaryAlert(true);
                }
              }}
              // locationData={locationData}
              showNoDataFoundMsg={false}
              showHeader
            />
          </div>
        </div>

        <div className="mt-3">
          <div className="marketing-inner-div">
            <Label className="header-style">Type of Sales Activities</Label>
            <span className="text-danger">{` * `}</span>
            <Row>
              <Col xs={12} md={4} className="mt-2">
                <MSelect
                  label="Type of Sales Activity"
                  value={activityDetails?.activityTypeId}
                  dataTestId="type"
                  hideLabel={true}
                  disabled
                  options={marketingTypes}
                />
              </Col>
              <Col xs={12} md={4} className="activity-date-picker">
                <MDatePicker
                  label="Activity Date & Time"
                  value={moment
                    .utc(activityDetails?.activityStartDate)
                    .format('DD-MM-YYYY H:mm A')}
                  onChange={() => {}}
                  format="DD-MM-YYYY hh:mm A"
                  icon={<Image src={Calendar}></Image>}
                  disabled
                />
              </Col>
            </Row>
          </div>
        </div>
        <Row className="mb-5">
          <Col
            xs={12}
            md={isActivityStatusSubmited ? 12 : 6}
            className="activity-log-margin"
          >
            <div className="marketing-inner-div">
              <Label className="m-2 header-style">Activity Log</Label>
              <div className="p-0 activity-log-div">
                <ul className="ul-item task-log-value">
                  {activityDetails?.notes.map((noteItem: any) => (
                    <li
                      className="mt-1"
                      key={`notes-${noteItem.notesid ?? noteItem.notesId}`}
                    >
                      {getUTCDate(noteItem)}
                      {noteItem.notesDescription}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Col>
          {!isActivityStatusSubmited && (
            <Col xs={12} md={6} className="activity-log-margin create-input">
              <div className="mb-2 marketing-inner-div">
                <Label for="comment" className="header-style">
                  Comments
                </Label>
                <Input
                  id="comment"
                  name="comment"
                  type="textarea"
                  value={comment}
                  maxLength={250}
                  className="rounded border model-comment-area comment-input"
                  onChange={(event) => {
                    setComment(event.target.value);
                  }}
                  placeholder="Enter comments"
                />
              </div>
              <div className="d-flex justify-content-end">
                <Image
                  className="me-2 cursor-pointer"
                  src={Cancel}
                  onClick={() => {
                    setComment('');
                  }}
                />
                {'    '}
                <Image
                  alt="imgSaveComment"
                  className="me-2 cursor-pointer"
                  src={!comment ? DisablesuccessTick : successTick}
                  onClick={() => {
                    onSaveComment();
                  }}
                />
              </div>
            </Col>
          )}
        </Row>

        <div className="d-flex justify-content-center mt-4 mb-2">
          <Button
            variant="primary"
            className="cl-btn-primary mt-2"
            onClick={() => {
              onUpdate(selectedEmployees, assignedEmployeeIds);
            }}
            disabled={
              activityDetails?.employeeList.length >= selectedEmployees.length
            }
          >
            Update
          </Button>
          <Button
            variant="primary-outline"
            className="mt-2 mx-4 cl-btn-outline-primary "
            onClick={() => {
              setUpdateActivity(false);
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
      {showAlertPopup && (
        <AlertPopUP isOpen={showAlertPopup} toggle={alertPopupToggle} />
      )}
      {showChangePrimaryAlert && (
        <AlertPopUP
          isOpen={showChangePrimaryAlert}
          toggle={changePrimaryToggle}
          title={'Are you sure you want to update?'}
        />
      )}
    </div>
  );
};

export default UpdateMarketingActivityPage;
